import { render, staticRenderFns } from "./csa.vue?vue&type=template&id=02ece973&scoped=true"
import script from "./csa.vue?vue&type=script&lang=ts"
export * from "./csa.vue?vue&type=script&lang=ts"
import style0 from "./csa.vue?vue&type=style&index=0&id=02ece973&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ece973",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02ece973')) {
      api.createRecord('02ece973', component.options)
    } else {
      api.reload('02ece973', component.options)
    }
    module.hot.accept("./csa.vue?vue&type=template&id=02ece973&scoped=true", function () {
      api.rerender('02ece973', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/csa/csa.vue"
export default component.exports